import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import "./oshar-page.css";
import "./oshar-real-estate.css";

const OsharRealEstateSuccessPage = () => {
  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Reservation received | Oshar Real Estate",
    description: "Stripe checkout return for Oshar VR real estate — not indexed.",
  });

  const location = useLocation();
  const [pageError, setPageError] = useState("");

  const stripeSessionId = useMemo(() => {
    try {
      return new URLSearchParams(location.search).get("session_id") || "";
    } catch (error) {
      return "";
    }
  }, [location.search]);

  useEffect(() => {
    try {
      new URLSearchParams(location.search);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Oshar success page query parse failed.");
      setPageError("Unable to read reservation details from the redirect URL.");
    }
  }, [location.search]);

  return (
    <div className="oshar-page oshar-re-page">
      <main style={{ minHeight: "70vh", display: "grid", placeItems: "center", padding: "72px 20px" }}>
        <section
          style={{
            width: "100%",
            maxWidth: 860,
            border: "1px solid rgba(201,165,74,0.35)",
            background: "rgba(5,12,26,0.9)",
            padding: 28,
          }}
        >
          <h1 className="oshar-re-section-title" style={{ textAlign: "left", marginBottom: 14 }}>
            Your Oshar virtual property access package has been reserved.
          </h1>
          <p className="oshar-re-section-lead" style={{ textAlign: "left", margin: 0 }}>
            Your payment was received. Connect your wallet later to claim the associated NFT deed/access asset when claim verification is enabled.
          </p>
          <div style={{ marginTop: 16, border: "1px solid rgba(201,165,74,0.25)", padding: 12, background: "rgba(8,14,30,0.74)" }}>
            <p style={{ margin: "0 0 6px", color: "#cfe0f4", fontSize: "0.82rem" }}>
              Stripe Session ID: {stripeSessionId || "Not provided"}
            </p>
            <p style={{ margin: 0, color: "#a8f0c2", fontSize: "0.82rem" }}>
              Reservation status: Payment received / verification pending
            </p>
          </div>
          {pageError && (
            <p className="oshar-re-modal__warn" style={{ marginTop: 10 }}>
              {pageError}
            </p>
          )}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 22 }}>
            <Link to="/world/oshar/real-estate" className="oshar-btn-outline">
              Return to Oshar Real Estate
            </Link>
            <Link to="/dashboard#oshar-access" className="oshar-btn-gold">
              Open My Dashboard
            </Link>
            <Link to="/world/oshar/real-estate" className="oshar-btn-outline">
              Connect Wallet Later
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default OsharRealEstateSuccessPage;
